import PropTypes from 'prop-types';
import TableContainer from '@mui/material/TableContainer';

import useDragScroll from 'hooks/useDragScroll';

const scrollbarSx = {
  '&::-webkit-scrollbar': { height: 6, width: 6 },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 3,
    bgcolor: 'rgba(31, 91, 64, 0.22)'
  },
  '&::-webkit-scrollbar-track': { bgcolor: 'transparent' }
};

// ==============================|| SCROLLABLE TABLE CONTAINER ||============================== //

export default function ScrollableTableContainer({ children, sx = {}, ...other }) {
  const { ref, dragHandlers } = useDragScroll();

  return (
    <TableContainer
      ref={ref}
      {...dragHandlers}
      sx={{
        overflowX: 'auto',
        overflowY: 'auto',
        cursor: 'grab',
        WebkitOverflowScrolling: 'touch',
        ...scrollbarSx,
        ...sx
      }}
      {...other}
    >
      {children}
    </TableContainer>
  );
}

ScrollableTableContainer.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};
